import { BILLING_ADDRESS_REGEX, CARD_HOLDER_NAME_REGEX, } from '../constants/regex';
import { getMaskedPhoneNumber } from './masking-field';
import { CreditCardBrands } from '../constants/credit-card';
export var getTextFieldStatus = function (error) {
    return error ? 'error' : undefined;
};
var isHDCard = function (cardBrand) {
    return cardBrand === CreditCardBrands.HDCOM ||
        cardBrand === CreditCardBrands.HDCON ||
        cardBrand === CreditCardBrands.PROX;
};
export var getAddressFormValues = function (address) {
    var cityState = address ? "".concat(address.city, ", ").concat(address.state) : '';
    return {
        isDefault: (address === null || address === void 0 ? void 0 : address.isDefault) || false,
        companyName: (address === null || address === void 0 ? void 0 : address.companyName) || '',
        primaryPhone: getMaskedPhoneNumber((address === null || address === void 0 ? void 0 : address.primaryPhone) || ''),
        alternatePhone: getMaskedPhoneNumber((address === null || address === void 0 ? void 0 : address.alternatePhone) || ''),
        firstName: (address === null || address === void 0 ? void 0 : address.firstName) || '',
        lastName: (address === null || address === void 0 ? void 0 : address.lastName) || '',
        nickName: (address === null || address === void 0 ? void 0 : address.nickName) || '',
        zipCode: (address === null || address === void 0 ? void 0 : address.zipCode) || '',
        addressLine1: (address === null || address === void 0 ? void 0 : address.addressLine1) || '',
        addressLine2: (address === null || address === void 0 ? void 0 : address.addressLine2) || '',
        cityState: cityState,
    };
};
export var getCreditCardFormValues = function (payment) {
    var cityState = (payment === null || payment === void 0 ? void 0 : payment.city) ? "".concat(payment.city, ", ").concat(payment.state) : '';
    var buyerId = (payment === null || payment === void 0 ? void 0 : payment.buyerId) || '';
    var cardNumberLast4 = (payment === null || payment === void 0 ? void 0 : payment.cardNumberLast4) || '';
    var cardNumber = '****' + cardNumberLast4 + ' ' + buyerId;
    return {
        isDefault: (payment === null || payment === void 0 ? void 0 : payment.isDefault) || false,
        cardNickname: (payment === null || payment === void 0 ? void 0 : payment.cardNickname) || '',
        cardNumber: cardNumber,
        cardHolderName: (payment === null || payment === void 0 ? void 0 : payment.cardHolderName) || '',
        cardExpiryMonth: (payment === null || payment === void 0 ? void 0 : payment.cardExpiryMonth) || '',
        cardExpiryYear: (payment === null || payment === void 0 ? void 0 : payment.cardExpiryYear) || '',
        addressLine1: (payment === null || payment === void 0 ? void 0 : payment.addressLine1) || '',
        addressLine2: (payment === null || payment === void 0 ? void 0 : payment.addressLine2) || '',
        zipCode: (payment === null || payment === void 0 ? void 0 : payment.zipCode) || '',
        cityState: cityState,
        isHDCard: isHDCard(payment === null || payment === void 0 ? void 0 : payment.cardBrand),
    };
};
export var isAllowedCharacter = function (key, field) {
    if (field === 'cardHolderName')
        return CARD_HOLDER_NAME_REGEX.test(key);
    if (field === 'addressLine1' || field === 'addressLine2')
        return BILLING_ADDRESS_REGEX.test(key);
    return false;
};
